import hasWhitespacesOnly from './common/hasWhitespacesOnly';
import incorrectDataType from './common/incorrectDataType';
import isEmpty from './common/isEmpty';
import isNull from './common/isNull';
import isUndefined from './common/isUndefined';

export const isValidDateOfBirth = (date_of_birth) => {
  if (
    isNull(date_of_birth) ||
    isUndefined(date_of_birth) ||
    incorrectDataType(date_of_birth, 'string') ||
    hasWhitespacesOnly(date_of_birth) ||
    isEmpty(date_of_birth)
  ) {
    return false;
  } else {
    const date_entered = new Date(date_of_birth);
    const date_now = new Date();
    const difference_months = date_now.getTime() - date_entered.getTime();
    const age_date = new Date(difference_months); // miliseconds from epoch
    const age = Math.abs(age_date.getUTCFullYear() - 1970);
    return age >= 23 && age <= 57;
  }
};
